import React, { ElementType } from 'react';
import {
  Icon,
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
  Text,
} from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { ActiveLink } from './ActiveLink';
import { useSidebar } from '../../hooks/useSidebar';

interface NavLinkProps extends ChakraLinkProps {
  icon?: ElementType;
  children: string;
  to: string;
  disabled?: boolean;
  shouldMatchExactHref?: boolean;
}

export const NavLink: React.FC<NavLinkProps> = ({
  icon,
  to,
  children,
  disabled = false,
  shouldMatchExactHref = false,
  ...props
}) => {
  const history = useLocation();
  const { isOpen, onClose } = useSidebar();

  return (
    <ActiveLink
      to={disabled ? `${history.pathname}${history.search}` : to}
      shouldMatchExactHref={shouldMatchExactHref}
      onClick={onClose}
    >
      <ChakraLink
        display="flex"
        gridGap={4}
        {...props}
        as="button"
        style={{ textDecoration: 'none', boxShadow: 'none' }}
        disabled={disabled}
        _disabled={{ color: 'gray.500', cursor: 'auto' }}
      >
        {icon && (
          <Icon as={icon} fontSize="20px" title={!isOpen ? children : ''} />
        )}

        {isOpen && (
          <Text
            fontWeight="medium"
            fontSize="14px"
            whiteSpace="normal"
            textAlign="start"
          >
            {children}
          </Text>
        )}
      </ChakraLink>
    </ActiveLink>
  );
};
